
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(43650|5606)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
